import rayImg from '../Asset/img/ray.jpg'
import joeImg from '../Asset/img/joe.jpeg'
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa'
export const memData = [
    {
        id: 1,
        imgSrc: rayImg,
        memName: 'Raymond Owusu Ababio',
        expert: 'Cyber Intelligence',
        poss: 'Chief Executive Officer',
        bio: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi obcaecati numquam, quo nobis corporis aliquid illo magni veritatis consequuntur libero incidunt dolor, placeat velit dolore reiciendis, ab eum alias est. Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi obcaecati numquam, quo nobis corporis aliquid illo magni veritatis consequuntur libero incidunt dolor, placeat velit dolore reiciendis, ab eum alias est.',
        shortUrl: 'ray',
        fb: <FaFacebook className='m-ico'/>,
        ig: <FaInstagram className='m-ico'/>,
        lIn: <FaLinkedin className='m-ico'/>,
        tw: <FaTwitter className='m-ico'/>
    },
    {
        id: 2,
        imgSrc: rayImg,
        memName: 'Aidoo Musah Razak',
        expert: 'Product Manager',
        poss: 'General Manager',
        bio: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi obcaecati numquam, quo nobis corporis aliquid illo magni veritatis consequuntur libero incidunt dolor, placeat velit dolore reiciendis, ab eum alias est. Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi obcaecati numquam, quo nobis corporis aliquid illo magni veritatis consequuntur libero incidunt dolor, placeat velit dolore reiciendis, ab eum alias est.',
        shortUrl: 'ray',
        fb: <FaFacebook className='m-ico'/>,
        ig: <FaInstagram className='m-ico'/>,
        lIn: <FaLinkedin className='m-ico'/>,
        tw: <FaTwitter className='m-ico'/>
    },
    {
        id: 3,
        imgSrc: joeImg,
        memName: 'Kwarteng Joseph',
        expert: 'Snr Developer',
        poss: 'Chief Technology Officer',
        bio: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi obcaecati numquam, quo nobis corporis aliquid illo magni veritatis consequuntur libero incidunt dolor, placeat velit dolore reiciendis, ab eum alias est. Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi obcaecati numquam, quo nobis corporis aliquid illo magni veritatis consequuntur libero incidunt dolor, placeat velit dolore reiciendis, ab eum alias est.',
        shortUrl: 'ray',
        fb: <FaFacebook className='m-ico'/>,
        ig: <FaInstagram className='m-ico'/>,
        lIn: <FaLinkedin className='m-ico'/>,
        tw: <FaTwitter className='m-ico'/>
    },
    {
        id: 4,
        imgSrc: rayImg,
        memName: 'Oppong Asamoah Joseph',
        expert: 'Web | Graphic Designing',
        poss: 'Product Designer',
        bio: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi obcaecati numquam, quo nobis corporis aliquid illo magni veritatis consequuntur libero incidunt dolor, placeat velit dolore reiciendis, ab eum alias est. Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi obcaecati numquam, quo nobis corporis aliquid illo magni veritatis consequuntur libero incidunt dolor, placeat velit dolore reiciendis, ab eum alias est.',
        shortUrl: 'ray',
        fb: <FaFacebook className='m-ico'/>,
        ig: <FaInstagram className='m-ico'/>,
        lIn: <FaLinkedin className='m-ico'/>,
        tw: <FaTwitter className='m-ico'/>
    },
]